import { Group, Title, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconEdit } from '@tabler/icons-react';
import { useTranslation } from '../../contexts/hooks';
import { useMobileMenu } from '../../contexts/hooks';
import { LanguageSelector } from '../common/LanguageSelector';
import { SocialShare } from '../common/SocialShare';
import { MobileMenu } from '../common/MobileMenu';

export function AppHeader() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const mobileMenuContext = useMobileMenu();
  
  return (
    <Group h="100%" px="md" justify="space-between">
      <Group>
        <Group gap="xs">
          <IconEdit style={{ width: isMobile ? 24 : 30, height: isMobile ? 24 : 30 }} color="blue" />
          <Title order={isMobile ? 4 : 3}>{t('app.title')}</Title>
        </Group>
      </Group>
      
      {/* Desktop: Show subtitle in the middle */}
      {!isMobile && (
        <Text size="sm" c="dimmed" style={{ textAlign: 'center', flex: 1 }}>
          {t('editor.subtitle')}
        </Text>
      )}
      
      {/* Mobile: Show hamburger menu */}
      {isMobile && (
        <MobileMenu
          pdfFile={mobileMenuContext.pdfFile}
          isTopSectionExpanded={mobileMenuContext.isTopSectionExpanded}
          onToggleTopSection={mobileMenuContext.onToggleTopSection}
        />
      )}
      
      {!isMobile && (
        <Group>
          <SocialShare size="sm" />
          <LanguageSelector />
        </Group>
      )}
    </Group>
  );
}
